import baseTheme from './PippoTheme';

const theme = {
  headerMaterialDark: '#b1125d',
  headerMaterialLight: '#209e34',
};

export default { ...baseTheme, ...theme };
